import { ReactNode } from 'react'
import Portal from 'components/portal'

/**
 * The wizard's «ادامه» bar.
 *
 * Portaled to <body> on purpose: every route layout in this app wraps its
 * Outlet in a framer-motion div that keeps a `transform` after the page
 * transition finishes, and a transformed ancestor becomes the containing
 * block for `position: fixed`. Left in place, this bar pins to the bottom of
 * the *page* — which on a long list means hundreds of pixels below the fold,
 * and a manager who taps a member and sees nothing happen.
 *
 * Two elements, not one: `md:px-[35%]` reproduces the desktop phone frame,
 * but padding is inside the box, so a background on the positioning element
 * paints the whole viewport and only pushes the contents inward.
 */
export default function StickyAction({
    children,
    summary,
}: {
    children: ReactNode
    /**
     * The consequence of what is on screen, pinned next to the button that
     * commits to it — «هر قسط حدود X» belongs beside «ادامه», not at the
     * bottom of a card the manager has to scroll back up from.
     */
    summary?: ReactNode
}) {
    return (
        <Portal>
            <div className=" fixed bottom-0 left-0 right-0 z-40 md:px-[35%]">
                <div className=" border-t border-divider bg-white px-4 pb-4 pt-3">
                    {summary && <div className=" mb-2">{summary}</div>}
                    {children}
                </div>
            </div>
        </Portal>
    )
}
